import gql from 'graphql-tag';

export const CREATE_SCHOOL = gql`
  mutation CreateSchool($input: CreateSchoolInput!) {
    createSchool(input: $input) {
      _id
      address
      contact {
        email
        firstName
        lastName
        phone
      }
      iaCredit
      type
      categories
    }
  }
`;

export const UPDATE_SCHOOL = gql`
  mutation UpdateSchool($id: ID!, $input: CreateSchoolInput!) {
    updateSchool(id: $id, input: $input)
  }
`;

export const RESEND_ACTIVATION_LINK = gql`
  mutation ResendActivationLink($input: ResendActivationLinkInput!) {
    resendActivationLink(input: $input)
  }
`;
